import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

// Print (measurements) and measurement-delete dialogs — shared across the measurements tab,
// not specific to nutrition or exercise.
const SharedDialogs = ({
  printDialogOpen,
  setPrintDialogOpen,
  printSelection,
  setPrintSelection,
  printLoading,
  handlePrintSubmit,
  deleteDialog,
  setDeleteDialog,
  actionLoading,
  measurementsLoading,
  confirmDeleteComposition,
}) => (
  <>
    <Dialog open={printDialogOpen} onOpenChange={(open) => (!open ? setPrintDialogOpen(false) : null)}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Print measurements</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-slate-600">Choose which measurements to include.</p>
          <select
            value={printSelection}
            onChange={(e) => setPrintSelection(e.target.value)}
            disabled={printLoading}
            className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-800 focus:border-fitness-primary focus:outline-none disabled:cursor-not-allowed disabled:opacity-70"
          >
            <option value="all">All measurements</option>
            <option value="composition">Composition</option>
            <option value="circumference">Circumference</option>
            <option value="vitals">Vitals</option>
          </select>
        </div>
        <DialogFooter className="sm:justify-end sm:space-x-2">
          <button
            type="button"
            onClick={() => setPrintDialogOpen(false)}
            disabled={printLoading}
            className="inline-flex items-center justify-center rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handlePrintSubmit}
            disabled={printLoading}
            className="inline-flex items-center justify-center rounded-md bg-fitness-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-sm transition hover:bg-fitness-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {printLoading ? 'Generating...' : 'Submit'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

    <Dialog open={!!deleteDialog} onOpenChange={(open) => (!open ? setDeleteDialog(null) : null)}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{deleteDialog?.type === 'circumference' ? 'Delete circumference entry?' : 'Delete composition entry?'}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">This will permanently remove the selected record.</p>
        <DialogFooter className="sm:justify-end sm:space-x-2">
          <button
            type="button"
            onClick={() => setDeleteDialog(null)}
            disabled={actionLoading || measurementsLoading}
            className="inline-flex items-center justify-center rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirmDeleteComposition}
            disabled={actionLoading || measurementsLoading}
            className="inline-flex items-center justify-center rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Delete
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
)

export default SharedDialogs
